module.exports = __webpack_public_path__ + "img/question.cb6d27b8.svg";